import { theme } from '@client/theme/constants';
import type { ThemeOptions } from '@mui/material';

const Toolbar: ThemeOptions['components'] = {
  MuiToolbar: {
    styleOverrides: {
      root: {
        minHeight: theme.spacing(3),
      },
    },
  },
};

export default Toolbar;
